export default __webpack_public_path__ + "static/media/vyapar.d7a4d73e.png";